import script from "./JBoxTable.vue?vue&type=script&setup=true&lang=js"
export * from "./JBoxTable.vue?vue&type=script&setup=true&lang=js"

import "./JBoxTable.vue?vue&type=style&index=0&id=6ede980c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ede980c"]])

export default __exports__